var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPrompterSuggestionDefaultIcon = function SvgIconPrompterSuggestionDefaultIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_default_icon_svg__a)",
    d: "M5 14V3.5h2.5c-.4 4 2.166 5 3.5 5V14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_default_icon_svg__b)",
    d: "M5 14V3.5h2.5c-.4 4 2.166 5 3.5 5V14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_default_icon_svg__c)",
    d: "m12.007 6.277-.15.34a.308.308 0 0 1-.566 0l-.149-.34a2.63 2.63 0 0 0-1.345-1.35l-.461-.203a.32.32 0 0 1-.187-.289.32.32 0 0 1 .187-.288l.435-.192a2.64 2.64 0 0 0 1.364-1.396l.154-.366A.3.3 0 0 1 11.574 2a.31.31 0 0 1 .286.193l.153.366c.258.621.746 1.12 1.365 1.396l.435.191a.32.32 0 0 1 .187.29.32.32 0 0 1-.187.288l-.46.203a2.63 2.63 0 0 0-1.346 1.35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_default_icon_svg__d)",
    d: "m12.007 6.277-.15.34a.308.308 0 0 1-.566 0l-.149-.34a2.63 2.63 0 0 0-1.345-1.35l-.461-.203a.32.32 0 0 1-.187-.289.32.32 0 0 1 .187-.288l.435-.192a2.64 2.64 0 0 0 1.364-1.396l.154-.366A.3.3 0 0 1 11.574 2a.31.31 0 0 1 .286.193l.153.366c.258.621.746 1.12 1.365 1.396l.435.191a.32.32 0 0 1 .187.29.32.32 0 0 1-.187.288l-.46.203a2.63 2.63 0 0 0-1.346 1.35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_default_icon_svg__e)",
    fillRule: "evenodd",
    d: "M3.5 14.65c-1.24 0-2.15-1.079-2.15-2.287V4.97c0-1.209.91-2.288 2.15-2.288h4.125a.65.65 0 0 1 .634.793c-.17.756-.208 1.856.161 2.73.18.423.449.781.838 1.038C9.648 7.5 10.202 8 11 8c.244 0 .5.017.567.017H14a.65.65 0 0 1 .65.65v3.696c0 1.208-.91 2.287-2.15 2.287zm2.15-1.3h4.7V8.948c-.711-.08-1.311-.293-1.807-.618-.639-.421-1.059-1-1.32-1.618-.38-.898-.437-1.9-.357-2.729H5.65zm-1.3-9.367H3.5c-.417 0-.85.388-.85.988v.38h1.7zm0 2.667h-1.7v1.367h1.7zm0 2.667h-1.7v1.366h1.7zm0 2.666v1.367H3.5c-.417 0-.85-.387-.85-.987v-.38zm7.3-2.666v1.366h1.7V9.317zm1.7 2.666h-1.7v1.367h.85c.417 0 .85-.387.85-.987zM8.654 4.96a.966.966 0 0 1 .411-1.403l.009-.004.433-.19a2 2 0 0 0 1.028-1.052v-.003l.152-.361a.95.95 0 0 1 .887-.596.96.96 0 0 1 .887.596l.152.362v.002c.194.466.56.842 1.028 1.05h.001l.44.195a.97.97 0 0 1 .568.88.97.97 0 0 1-.568.88l-.007.004-.46.203a1.98 1.98 0 0 0-1.013 1.015v.002l-.15.34c-.337.764-1.419.767-1.756 0l-.15-.34v-.002a1.98 1.98 0 0 0-1.012-1.016l-.469-.206a.97.97 0 0 1-.41-.356m1.614-.525a3.3 3.3 0 0 0 1.306-1.292c.303.545.756.994 1.307 1.292-.546.29-1 .726-1.307 1.26a3.3 3.3 0 0 0-1.306-1.26",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_default_icon_svg__f)",
    fillRule: "evenodd",
    d: "M3.5 14.65c-1.24 0-2.15-1.079-2.15-2.287V4.97c0-1.209.91-2.288 2.15-2.288h4.125a.65.65 0 0 1 .634.793c-.17.756-.208 1.856.161 2.73.18.423.449.781.838 1.038C9.648 7.5 10.202 8 11 8c.244 0 .5.017.567.017H14a.65.65 0 0 1 .65.65v3.696c0 1.208-.91 2.287-2.15 2.287zm2.15-1.3h4.7V8.948c-.711-.08-1.311-.293-1.807-.618-.639-.421-1.059-1-1.32-1.618-.38-.898-.437-1.9-.357-2.729H5.65zm-1.3-9.367H3.5c-.417 0-.85.388-.85.988v.38h1.7zm0 2.667h-1.7v1.367h1.7zm0 2.667h-1.7v1.366h1.7zm0 2.666v1.367H3.5c-.417 0-.85-.387-.85-.987v-.38zm7.3-2.666v1.366h1.7V9.317zm1.7 2.666h-1.7v1.367h.85c.417 0 .85-.387.85-.987zM8.654 4.96a.966.966 0 0 1 .411-1.403l.009-.004.433-.19a2 2 0 0 0 1.028-1.052v-.003l.152-.361a.95.95 0 0 1 .887-.596.96.96 0 0 1 .887.596l.152.362v.002c.194.466.56.842 1.028 1.05h.001l.44.195a.97.97 0 0 1 .568.88.97.97 0 0 1-.568.88l-.007.004-.46.203a1.98 1.98 0 0 0-1.013 1.015v.002l-.15.34c-.337.764-1.419.767-1.756 0l-.15-.34v-.002a1.98 1.98 0 0 0-1.012-1.016l-.469-.206a.97.97 0 0 1-.41-.356m1.614-.525a3.3 3.3 0 0 0 1.306-1.292c.303.545.756.994 1.307 1.292-.546.29-1 .726-1.307 1.26a3.3 3.3 0 0 0-1.306-1.26",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_default_icon_svg__a",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_default_icon_svg__b",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_default_icon_svg__c",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_default_icon_svg__d",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_default_icon_svg__e",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_default_icon_svg__f",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })))));
};
export default SvgIconPrompterSuggestionDefaultIcon;